// Module
var code = "<style>:host{display:flex;height:max-content;width:max-content}#selector{box-shadow:0 1px 4px 0 rgba(0,0,0,.37);border:none;background-color:var(--color-surface);border-radius:8px;height:100%;font-size:1em;padding:5px;cursor:pointer}</style> <select id=\"selector\"></select>";
// Exports
export default code;